import { PropsWithChildren, useCallback, useEffect, useMemo, useState } from "react"
import { uniqueId } from "lodash"
import { AdminUserContextProvider } from "./AdminUser"
import useApi from "../hooks/useApi"
import { AxiosError } from "axios"
import { createPortal } from "react-dom"
import { CookiesProvider } from "react-cookie"
import { OscContextProvider } from "./Osc"

const ApplicationProvider = ( { children }:Props ) => {

  const [ messages, setMessages ] = useState<string[]>( [] )
  const api = useApi()
  const body = useMemo( () => {
    return document.querySelector('body')
  }, [ ] )

  const hiddeMessages = useCallback( (  ) => {
    setMessages( [] )
  }, [] )

  useEffect( () => {
    api.interceptors.response.use( req => req, ( error:AxiosError ) => {
        const messages:string[] = []
        error.response?.data?.messages?.forEach( (m: string) => {
            m && messages.push( m )
        } )
        if( error?.response?.status === 403 ) {
            messages.push( 'Não Autorizado' )
        }
        if( messages.length > 0 ){
            setMessages( messages )
            setTimeout( hiddeMessages, 3500 )
        }

        return Promise.reject( error )
    })
  }, [ hiddeMessages, api ] )

  return (
    <CookiesProvider>
        <AdminUserContextProvider>
            <OscContextProvider>
                {
                    messages.length > 0 && body && createPortal(
                        <div className="fixed top-10 right-4 flex flex-col" style={{ zIndex: 100 }}>
                            {
                            messages.map( m => (
                                <span
                                key={ uniqueId() }
                                className={ [
                                    'mb-4',
                                    'text-white',
                                    'bg-red-500',
                                    'rounded-lg',
                                    '',
                                    'p-4',
                                ].join( ' ' ) }
                                >
                                { m }
                                </span>
                            ))
                            }
                        </div>, body )

                }
                { children }
            </OscContextProvider>
        </AdminUserContextProvider>
    </CookiesProvider>
  )
}

interface Props extends PropsWithChildren< any >{

}
export { ApplicationProvider }
